export enum DeviceType {
    PHONE = "device-phone",
    TABLET_PORTRAIT = "device-tablet-portrait",
    TABLET_LANDSCAPE = "device-tablet-landscape",
    DESKTOP_OR_LAPTOP = "device-desktop-or-laptop"
}